module.exports = __webpack_public_path__ + "img/giphy.e42fd33b.gif";